<template>

  <v-layout>
    <v-flex xs12>
      <v-footer absolute height="auto" color="blue-grey lighten-4" light>
        <v-layout justify-center row wrap>
          <div v-for="(footerlink, index) in footerlinks" :key="index">
            <div v-if="footerlink.href">
              <div v-if="footerlink.icon">
                <v-btn flat round icon :href="footerlink.linkroute" target="_blank">
                  <v-icon medium>{{footerlink.icon}}</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  round
                  flat
                  active-class
                  :href="footerlink.linkroute"
                  target="_blank"
                  class="footerlinks"
                >
                  {{ footerlink.linkname}}
                </v-btn>
              </div>
            </div>
            <div v-else>
              <v-btn
                round
                flat
                active-class
                :to="{ name: `${footerlink.linkroute}`}"
                class="footerlinks"
              >
                {{ footerlink.linkname }}
              </v-btn>
            </div>
          </div>
        </v-layout>
      </v-footer>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  data: () => ({
    footerlinks: [
      /*
      {
        linkname: "Home",
        linkroute: "/",
        href: false
      },
      {
        linkname: "About",
        linkroute: "TkAboutView",
        href: false
      },
      */
      {
        linkname: "TkWebDev23",
        linkroute: "https://www.tkwebdev23.com",
        icon: '',
        href: true
      },
      {
        linkname: "docs.TkWebDev23",
        linkroute: "https://docs.tkwebdev23.com",
        icon: '',
        href: true
      },
      {
        linkname: "Contacts",
        linkroute: "TkContacts",
        icon: '',
        href: false
      },
      {
        linkname: "About",
        linkroute: "TkAboutView",
        icon: '',
        href: false
      },
      /*
      {
        linkname: "Technical",
        linkroute: "TkTechnical",
        icon: '',
        href: false
      },
      */
      {
        linkname: "",
        linkroute: "https://www.facebook.com/timmyskittys1",
        icon: 'fab fa-facebook-square',
        href: true
      },
    ]
  })
};
</script>

<style scoped>
.footerlinks {
  font-size: 1rem;
  /* color: #008aff; */
}
</style>


// WEBPACK FOOTER //
// src/components/FooterView.vue